import { render, staticRenderFns } from "./disc.vue?vue&type=template&id=a7423c0a&scoped=true&"
import script from "./disc.vue?vue&type=script&lang=js&"
export * from "./disc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7423c0a",
  null
  
)

export default component.exports